import { render, staticRenderFns } from "./Anumerta.vue?vue&type=template&id=624abc08"
import script from "./Anumerta.vue?vue&type=script&lang=js"
export * from "./Anumerta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports